import React, {useCallback, useContext, useEffect, useState} from 'react';
import {NavBar} from 'Components/Nav/NavBar';
import s from './styles/BlogPost.module.scss';
import Footer from './Footer';
import {useLocation} from "react-router-dom";
import {Root} from "../../Api/Root";
import {getDeviceId, isLoggedIn, SessionContext} from "../../Utils/sessions";
import Button from "react-bootstrap/esm/Button";
import {BACKUP_BLOG_CONTENT} from "./Blogs";
import Modal from "react-bootstrap/Modal";
import {LoginForm} from "./Login";
import SideBar from "../../Components/Nav/SideBar";
import {RiArrowGoBackLine} from "react-icons/ri";
import {AiFillLike, AiOutlineLike, AiOutlineShareAlt} from "react-icons/ai";
import {logElementInteraction} from "../../Api/Utils/referral";

export const BlogPostDisplay = () => {
    const {session} = useContext(SessionContext);
    const [searchBarPlaceHolder, setSearchBarPlaceholder] = useState('Search for a blog')

    let counter = 0;

    useEffect(() => {
        const intervalId = setInterval(() => {
            counter++;
            setSearchBarPlaceholder(placeHolderOptions[counter % 5]);
        }, 3000);

        return () => clearInterval(intervalId);
    }, []);


    const placeHolderOptions = [
        `"A student studying computer science"`,
        `"A junior at a college near me"`,
        `"Someone who's interested in art"`,
        `"A student athlete"`,
        `"Some who's also shy, like me"`]

    function onQueryChange () {

    }

    if (isLoggedIn(session)) {
        return <>
            <div>
                <SideBar session={session} title={"Blogs"} placeholder={searchBarPlaceHolder}  suggestions={[]} onQueryChange={onQueryChange} >
                    <BlogPost />
                </SideBar>
            </div>
        </>
    }

    return <>
            <div>
                <header className={s.header}>
                    <NavBar dark={true}/>
                </header>
                <BlogPost />
            </div>
        <Footer/>
        </>
}

export const BlogPost = () => {
    const {session} = useContext(SessionContext);
    const [commentRequest, setCommentRequest] = useState({})
    const [commentReplyRequest, setCommentReplyRequest] = useState({})
    const [preventCommenting, setPreventCommenting] = useState(false)
    const [submitCommentError, setSubmitCommentError] = useState(undefined)
    const [submitCommentReplyError, setSubmitCommentReplyError] = useState(undefined)
    const [blogContent, setBlogContent] = useState(undefined)
    const [recommendedBlogs, setRecommendedBlogs] = useState(undefined)
    const [comments, setComments] = useState(undefined)
    const [replyCommentId, setReplyCommentId] = useState(undefined)
    const [replyCommentIndex, setReplyCommentIndex] = useState(undefined)
    const [likeCount, setLikeCount] = useState(undefined)
    const location = useLocation();
    const currentPath = location.pathname;
    const blogUri = currentPath.split("/")
        .at(currentPath.split("/").length - 1)

    function openNewBlog(uri) {
        const href = window.location.href;
        window.location.href = (`${href.split('/')[0]}/blog/posts/${uri}`);
    }

    function returnToBlogList() {
        const href = window.location.href;
        window.location.href = (`${href.split('/')[0]}/blogs`);
    }

    function handleCommentRequestChange(event) {
        let {name, value} = event.target
        setCommentRequest((prevState) => ({...prevState, [name]: value}));
    }

    function handleCommentReplyChange(event) {
        let {name, value} = event.target
        setCommentReplyRequest((prevState) => ({...prevState, [name]: value}));
    }

    function submitComment() {
        setSubmitCommentError(undefined)
        if (session.jwt) {
            Root.bloggingApi.addBlogPostComment({
                uri: blogUri,
                comment: commentRequest.comment,
                deviceId: getDeviceId(),
            }, session.jwt).then((res) => {
                setCommentRequest({})
                getComments()
            }).catch(() => {
                setSubmitCommentError("There was an issue submitting your comment, please try again later");
            })
        } else {
            setPreventCommenting(true);
        }
    }

    function submitCommentReply() {
        setSubmitCommentReplyError(undefined)
        if (session.jwt) {
            Root.bloggingApi.addBlogPostCommentReply({
                originalCommentId: replyCommentId,
                reply: commentReplyRequest.reply,
                deviceId: getDeviceId(),
            }, session.jwt).then((res) => {
                setReplyCommentIndex(undefined)
                setReplyCommentId(undefined)
                setCommentReplyRequest({})
                getComments()
            }).catch(() => {
                setSubmitCommentReplyError("There was an issue replying to the comment, please try again later");
            })
        } else {
            setPreventCommenting(true);
        }
    }

    function getComments() {
        Root.bloggingApi.getBlogPostComments({uri: blogUri, deviceId: getDeviceId(), userId: session?.id}).then((res) => {
            console.log(res.data?.comments)
            setComments(res.data?.comments || [])
        }).catch(() => {
            setComments(undefined)
        })
    }

    useEffect(() => {
        logElementInteraction( {
            elementId: `blogs::${blogUri}::${isLoggedIn(session) ? 'authenticated' : 'public'}`,
            type: 'VIEW',
            deviceId: getDeviceId(),
            data: localStorage.getItem('userInfo'),
            source: 'WEB'
        }).then(() => {}).catch(() => {});
    }, [blogUri, session])

    useEffect(() => {
        fetch(`https://cdn.cassy.dev/blogs/${blogUri}.json`)
            .then(response => {
                if (!response.ok) {
                    if (BACKUP_BLOG_CONTENT[blogUri]) {
                        setBlogContent(BACKUP_BLOG_CONTENT[blogUri])
                    } else {
                        setBlogContent(undefined)
                    }
                }
                return response.json(); // Parse the JSON body
            })
            .then(data => {
                setBlogContent(data)
            })
            .catch(() => {
                if (BACKUP_BLOG_CONTENT[blogUri]) {
                    setBlogContent(BACKUP_BLOG_CONTENT[blogUri])
                } else {
                    setBlogContent(undefined)
                }
            });

    }, [blogUri]);

    useEffect(() => {
        Root.bloggingApi.getRecommendedBlogs(blogUri, getDeviceId(), session?.jwt).then((res) => {
            setRecommendedBlogs(res.data)
        }).catch(() => {
            setRecommendedBlogs([])
        })
    }, [blogUri, session.jwt]);

    useEffect(() => {
        getComments()
    }, [getComments]);


    const getLikes = useCallback(() => {
        Root.bloggingApi.getBlogPostLikeCount(blogUri, getDeviceId()).then((res) => {
            setLikeCount(res.data)
        }).catch(() => {
            setLikeCount(undefined)
        })
    }, [blogUri]);

    useEffect(() => {
        getLikes()
    }, [getLikes]);


    function toggleLike() {
        if (session.jwt) {
            Root.bloggingApi.toggleBlogPostLike(blogUri, getDeviceId(), session.jwt).then((res) => {
                getLikes()
            }).catch(() => {
                setLikeCount(undefined)
            })
        } else {
            setPreventCommenting(true);
        }
    }

    function shareBlog() {
        navigator.share({
            title: blogContent.title,
            text: blogContent.description,
            url: `https://nxstep.co/blog/posts/${blogUri}`,
        });
    }

    return <>
        <div className={`${s.container} ${s.articleContainer}`}>
            <div className={`${s.contentWrapper} ${isLoggedIn(session) && s.authenticatedContentWrapper}`}>
                <aside className={s.leftSidebar}>
                    <Button className={`btnFill wide md fs-18 fw-bold ${s.blogBackButton}`} onClick={returnToBlogList}><RiArrowGoBackLine /><span className={'ms-2'}>All Blogs</span></Button>
                    <div className={s.tableOfContents}>
                        <h3 className={s.sidebarHeading}>Table of Contents</h3>
                        {blogContent ?
                            <>
                                <ul className={s.sidebarUl}>
                                    {blogContent.paragraphs?.map((paragraph) =>
                                        <>
                                            {paragraph.heading &&
                                                <li key={paragraph.heading.id}>
                                                    <a href={`#${paragraph.heading.id}`}>
                                                        <span className={s.tableOfContentsHeader}>{paragraph.heading.title}</span>
                                                    </a>
                                                </li>
                                            }
                                        </>
                                    )}
                                </ul>
                            </> :
                            <>
                                <div className={` ${s.textPlaceHolder} ${s.shimmerBg}`}></div>
                                <div className={` ${s.textPlaceHolder} ${s.shimmerBg}`}></div>
                                <div className={` ${s.textPlaceHolder} ${s.shimmerBg}`}></div>
                            </>}
                    </div>
                </aside>

                <main className={s.mainArticleContent}>
                    {blogContent ?
                        <>
                            <article className={s.articleCard}>
                                <header className={s.articleHeader}>
                                    <h1 className={s.articleTitle}>
                                        {blogContent.title}
                                    </h1>
                                    <div className={s.articleControls}>
                                        <div className={s.articleMeta}>
                                            <img src={blogContent.author?.avatar}
                                                 alt={`${blogContent.author?.name} avatar`}
                                                 className={s.articleAuthorImg}/>
                                            <div>
                                                <span>{blogContent.author?.name}</span>
                                                <span>{new Date(blogContent.dateString).toDateString()}</span>
                                                <span>{blogContent.duration} minute read</span>
                                            </div>
                                        </div>

                                        <div className={s.articleLikeAndShare}>
                                            <Button className={`btnLink p-0 me-2`} onClick={toggleLike}><span className={s.likeCount}>{likeCount?.count}</span>{likeCount?.readerLikes ?
                                                <AiFillLike color={'green'} size={24}/> :
                                                <AiOutlineLike color={'green'} size={24}/>}</Button>
                                            <Button className={'btnLink p-0 me-2'} onClick={shareBlog}><AiOutlineShareAlt size={24} /></Button>
                                        </div>
                                    </div>
                                </header>

                                {blogContent.keyTakeaways &&
                                    <section className={s.keyTakeaways}>
                                        <h2>Key takeaways</h2>
                                        <ul>
                                            {blogContent.keyTakeaways?.map((takeaway, idx) =>
                                                <li key={idx}>
                                                    {takeaway}
                                                </li>
                                            )}
                                        </ul>
                                    </section>
                                }

                                {blogContent.heroImageUrl &&
                                    <figure className={s.articleFigure}>
                                        <img
                                            src={blogContent.heroImageUrl}
                                            alt={`${blogContent.title} Visual`}
                                            className={s.articleImage}/>
                                    </figure>
                                }

                                <section className={s.proseStyles}>
                                    {blogContent.paragraphs?.map((paragraph) =>
                                        <>
                                            {paragraph.imageUrl &&
                                                <figure className={s.articleFigure}>
                                                    <img
                                                        src={paragraph.imageUrl}
                                                        alt="Crypto Staking Visual" className={s.articleImage}/>
                                                </figure>
                                            }
                                            {paragraph.heading &&
                                                <h2 id={paragraph.heading.id}>{paragraph.heading.title}</h2>}
                                            {paragraph.text && <p>{paragraph.text}</p>}
                                        </>
                                    )}
                                </section>
                            </article>
                        </> :
                        <>
                            <article className={s.articleCard}>
                                <header className={s.articleHeader}>
                                    <div className={` ${s.titlePlaceHolder} ${s.shimmerBg}`}/>
                                    <div className={` ${s.subtitlePlaceHolder} ${s.shimmerBg}`}/>
                                </header>

                                <section className={`${s.keyTakeawaysPlaceholder} ${s.shimmerBg}`}/>

                                <section className={s.proseStyles}>
                                    <div className={` ${s.textPlaceHolder} ${s.shimmerBg}`}/>
                                    <div className={` ${s.textPlaceHolder} ${s.shimmerBg}`}/>
                                    <div className={` ${s.textPlaceHolder} ${s.shimmerBg}`}/>
                                    <div className={` ${s.textPlaceHolder} ${s.shimmerBg}`}/>
                                    <div className={` ${s.textPlaceHolder} ${s.shimmerBg}`}/>
                                </section>
                            </article>
                        </>}
                    <section className={s.commentsSection}>
                        {preventCommenting &&
                            <Modal show={preventCommenting} onHide={() => setPreventCommenting(false)}>
                                <Modal.Header closeButton/>
                                <Modal.Title>
                                    {session.jwt ?
                                        <>
                                            <div className='text-center'>Sign in successful</div>
                                            <p className='fs-16 text-muted text-center m-3 mt-2'>You may now like and engage
                                                in the discussion. Please remember to be respectful and considerate
                                                of others.</p>
                                        </> :
                                        <>
                                            <div className='text-center'>Sign in to comment</div>
                                            <p className='fs-16 text-muted text-center m-3 mt-2'>To like the post and
                                                contribute to the conversation you must be currently enrolled in a
                                                college or actively exploring colleges to attend in the future.</p>

                                        </>
                                    }
                                </Modal.Title>
                                {!session.jwt &&
                                    <Modal.Body>
                                        <div className='align-content-center m-3 mt-2'>
                                            <LoginForm userType={''} onSuccess={() => {
                                            }}/>
                                        </div>
                                    </Modal.Body>
                                }
                            </Modal>
                        }
                        {comments && comments.length > 0 &&
                            <>
                                <h2 className={s.commentsHeading}>Comments</h2>
                                {comments.map((comment, idx) =>
                                    <>
                                        <div key={idx} className={s.commentsList}>
                                            <div className={s.commentItem}>
                                                <p className={s.commentAuthor}>{comment.name} <span
                                                    className={s.commentDate}>- {new Date(comment.dateString).toDateString()}</span>
                                                </p>
                                                <p className={s.commentText}>{comment.comment}</p>

                                                {replyCommentIndex === idx &&
                                                    <form className={s.commentForm}>
                                                        <div>
                                                        <textarea id="comment-reply-text" name="reply" rows="4"
                                                                  value={commentReplyRequest.reply || ''}
                                                                  autoFocus={true}
                                                                  placeholder={'Your reply'}
                                                                  onChange={handleCommentReplyChange}
                                                                  required></textarea>
                                                        </div>
                                                    </form>
                                                }

                                                <div className={''}>
                                                    {replyCommentIndex === idx ?
                                                        <>
                                                            <Button className={`btnLink p-0 ${s.commentReplyCancelButton}`} onClick={() => {
                                                                setReplyCommentIndex(undefined)
                                                                setReplyCommentId(undefined)
                                                                setCommentReplyRequest({})
                                                                setSubmitCommentReplyError(undefined)
                                                            }}>
                                                                Cancel
                                                            </Button>
                                                            <Button className={`btnLink p-0 ms-4 ${s.commentReplyButton}`} disabled={!commentReplyRequest.reply} onClick={() => {
                                                                submitCommentReply(comment.id)
                                                            }}>
                                                                Submit
                                                            </Button>
                                                        </> :
                                                        <>
                                                            <Button className={`btnLink p-0`} onClick={() => {
                                                                setCommentReplyRequest({})
                                                                setReplyCommentIndex(idx)
                                                                setReplyCommentId(comment.id)
                                                            }}>
                                                                Reply
                                                            </Button>
                                                        </>}
                                                    {submitCommentReplyError &&
                                                        <p style={{color: 'red', marginTop: '8px'}}>{submitCommentReplyError}</p>}
                                                </div>
                                                <div>
                                                    {comment.replies && comment.replies.map((reply, idx) =>
                                                        <>
                                                        <div key={idx} className={`${s.commentItem} m-3 w-auto`}>
                                                            <p className={s.commentAuthor}>{reply.name} <span
                                                                className={s.commentDate}>- {new Date(reply.dateString).toDateString()}</span>
                                                            </p>
                                                            <p className={s.commentText}>{reply.comment}</p>
                                                        </div>
                                                        </>
                                                        )}
                                                        </div>
                                                        </div>
                                                        </div>
                                                        </>)}
                                                </>
                                                }
                                                <h2 className={s.commentsHeading}>Leave {comments?.length > 0 ? `a` : `the first`} comment</h2>
                                                <form className={s.commentForm}>
                                                    <div>
                                                    <label htmlFor="comment-name">Name:</label>
                                {session?.id ?
                                    <>
                                        <input disabled={true} type="text" id="comment-name" name="name"
                                               placeholder={session?.firstName || 'Your name will be visible'}
                                               value={commentRequest.name} required/>
                                    </> :
                                    <>
                                        <input disabled={true} type="text" id="comment-name" name="name"
                                               placeholder={'Sign in or create your account to join in the discussion!'}
                                               required/>
                                    </>
                                }
                            </div>
                            <div>
                                <label htmlFor="comment-text">Comment:</label>
                                <textarea id="comment-text" name="comment" rows="4"
                                          value={commentRequest.comment || ''}
                                          onChange={handleCommentRequestChange}
                                          required></textarea>
                            </div>
                            <Button className={`btnFill md green`} disabled={session.jwt && !commentRequest.comment} onClick={submitComment}>Submit Comment</Button>
                            {submitCommentError &&
                                <p style={{color: 'red', marginTop: '8px'}}>{submitCommentError}</p>}
                        </form>
                    </section>
                </main>

                <aside className={s.rightSidebar}>
                    <div className={s.continuedReading}>
                        <h3 className={s.sidebarHeading}>Continue Reading</h3>
                        <div className={s.recommendedItemContainer}>
                            {recommendedBlogs ?
                                <>
                                    {recommendedBlogs.map((recommendedBlog, idx) =>
                                        <>
                                            <div role={'link'} key={idx}
                                                 onClick={() => openNewBlog(recommendedBlog.uri)}
                                                 className={s.recommendedItemCard}>
                                                <img src={recommendedBlog.coverUrl}
                                                     alt="" className={s.recommendedItemCardImage}/>
                                                <div className={s.recommendedItemCardContent}>
                                                    <p className={s.recommendedItemCardTitle}>
                                                        {recommendedBlog.title}
                                                    </p>
                                                    <p className={s.recommendedItemCardDescription}>
                                                        {recommendedBlog.description}
                                                    </p>
                                                </div>
                                            </div>
                                        </>
                                    )}
                                </> :
                                <>
                                    <div className={s.recommendedItemCard}>
                                        <div className={`${s.recommendedItemCardImage} ${s.shimmerBg}`}/>
                                        <div className={s.recommendedItemCardContent}>
                                            <div className={` ${s.textPlaceHolder} ${s.shimmerBg}`}/>
                                            <div className={` ${s.textPlaceHolder} ${s.shimmerBg}`}/>
                                        </div>
                                    </div>
                                    <div className={s.recommendedItemCard}>
                                        <div className={`${s.recommendedItemCardImage} ${s.shimmerBg}`}/>
                                        <div className={s.recommendedItemCardContent}>
                                            <div className={` ${s.textPlaceHolder} ${s.shimmerBg}`}/>
                                            <div className={` ${s.textPlaceHolder} ${s.shimmerBg}`}/>
                                        </div>
                                    </div>
                                </>}
                        </div>
                    </div>
                </aside>
            </div>
        </div>
    </>
}